export {
  MedicationPackPhotoError,
  describeError,
  medicationCatalogKeys,
  useMedicationProductVariations,
  useMedicationQuickAdd,
  useResolveMedicationPackCode,
  useResolveMedicationPackPhoto,
  usePackPhotoScan,
} from "./useMedicationCatalog";
export type { MedicationQuickAddItem } from "./types";
export type { PackPhotoFailure, PackPhotoStage } from "./useMedicationCatalog";
export { canPhotographPackCode, preparePackPhoto } from "./photoCapture";
export {
  buildMedicationIdentityInput,
  createMedicationIdentityDraft,
  inferPatientMedicationForm,
  isFilledFromScan,
  matchTypedProduct,
  resolveCatalogProductName,
  normalizeProductName,
  withProductName,
} from "./identity";
export type { MedicationIdentityDraft } from "./identity";
export type {
  MedicationCatalogProduct,
  MedicationCodeResolution,
  MedicationIdentityInput,
  MedicationIdentitySource,
  MedicationPackPresentation,
  MedicationProductDimensions,
} from "./types";

// Kept from #3825: the document vault resolves a medication from extracted
// text, and a lookup made while a document is being read needs its own
// deadline rather than the form's.
export {
  findMedicationByName,
  resolveMedicationCatalogId,
} from "./catalog-match";
export type { MedicationCatalogItem } from "./catalog-match";
export { withMedicationLookupDeadline } from "./request-timeout";
